/** @format */

/* eslint-disable */
import React, { useState } from 'react'
import ModalTemplate from '../../../../../Components/ModalTemplate/ModalTemplate'
import localize from '../../../../../Global/Localize'
import { CustomerPartial } from '../../../../../Components/ReUsables/Customer/CustomerPartial'
import CustomerAccountPartial from '../../../../../Components/ReUsables/CustomerAccount/CustomerAccountPartial'
import ChartOfAccountsLookup from '../../../../../Components/Lookup/ChartOfAccountsLookup'
import { MaskNumber } from '../../../../../Components/InputMasks/MaskNumber'
import Tab from '../../../../../Components/Tabs/Tab'
import BankToBankRequestEntries from '../BankToBankRequestEntries'
import {
  apportionTo,
  apportionedComponent,
} from '../../../../../Global/enumeration'
import Swal from 'sweetalert2'
import { postData, putData } from '../../../../../Helpers/webApi'
import {
  formatCurrency,
  formatDate,
  stripNonNumericCharacters,
} from '../../../../../Helpers/formatters'
import BankToBankRequestCustomerAccounts from './BankToBankRequestCustomerAccounts'
import { GlobalValidationErrors } from '../../../../../Validation/ValidationState'
import LoanRepaymentModeLookup from '../../../../../Components/Lookup/LoanRepaymentModeLookup'
import EnumsServerCombo from '../../../../../Components/ComboBox/EnumsServerCombo'

function ReconcileBankToBankDataModal({
  mode,
  selectedBankToBankRequest,
  setSelectedBankToBankRequest,
  close,
  onSetMode,
  loadData,
}) {
  const [selectedCustomer, setSelectedCustomer] = useState({
    apportionedComponent: Object.keys(apportionedComponent)[2],
    apportionTo: Object.keys(apportionTo)[0],
  })
  const [selectedAccount, setSelectedAccount] = useState(null)
  const [EntriesToBeRemoved, setEntriesToBeRemoved] = useState([])
  const [apportionedAmount, setApportionedAmount] = useState(null)
  const [shortageAmount, setShortageAmount] = useState(null)
  const [refreshEntry, setRefreshEntry] = useState(false)

  function closeModal() {
    close()
    setGlobalValidationErrors({})
  }

  const handleOnSelectCustomer = customer => {
    if (!customer.isLocked) {
      setSelectedCustomer({
        ...selectedCustomer,
        apportionTo: selectedCustomer.apportionTo,
        ...customer,
      })
    } else {
      Swal.fire({
        icon: 'info',
        text: 'Selected Customer is Locked',
        title: 'Ooops!',
        showCloseButton: true,
      })
      setSelectedCustomer(null)
    }
  }

  const handleOnSelectAccount = account => {
    if (!account.isLocked) {
      setSelectedAccount({ ...selectedAccount, ...account })
    } else {
      Swal.fire({
        icon: 'info',
        text: 'Selected Account is Locked',
        title: 'Ooops!',
        showCloseButton: true,
      })
      setSelectedAccount(null)
    }
  }
  const addApportionmentEntry = async customer => {
    const apportionmentEntry = {
      customerAccountCustomerId: selectedCustomer.id,
      customerAccountId: selectedAccount?.id,
      chartOfAccountId: selectedCustomer?.chartOfAccountId,
      bankToBankRequestId: selectedBankToBankRequest?.id,
      loanRepaymentModeId: selectedCustomer?.loanRepaymentModeId,
      id: selectedBankToBankRequest.id,
      apportionTo: selectedCustomer?.apportionTo,
      apportionedComponent: selectedCustomer?.apportionedComponent,
      apportionedAmount: selectedCustomer?.apportionedAmount,
      remarks: selectedAccount?.remarks,
      createdBy: customer.createdBy,
      createdDate: customer.createdDate,
      transactionAmount: selectedBankToBankRequest.totalAmount,
    }

    const { success } = await postData(
      '/BankToBankRequest/create-bank-to-bank-request-entry',
      apportionmentEntry,
      true,
      'Operation Completed Successfully'
    )
    if (success) {
      setRefreshEntry(!refreshEntry)
      setSelectedCustomer({ apportionTo: selectedCustomer?.apportionTo })
      setSelectedAccount(null)
    }
  }

  const [globalValidationErrors, setGlobalValidationErrors] =
    GlobalValidationErrors.use()

  function clearValidation(column) {
    setGlobalValidationErrors(validation => {
      delete validation[column]
      return validation
    })
  }

  const handleRemoveEntry = async () => {
    if (EntriesToBeRemoved.length === 0) {
      Swal.fire({
        icon: 'info',
        text: 'Select Atleast One Entry',
        title: 'Ooops!',
        showCloseButton: true,
      })
      return
    }
    const { success } = await putData(
      '/BankToBankRequest/remove-bank-to-bank-request-entries',
      EntriesToBeRemoved,
      true,
      `Entries Removed`
    )
    if (success) {
      setEntriesToBeRemoved([])
      setRefreshEntry(!refreshEntry)
    }
  }

  async function handleSubmit() {
    const { success } = await putData(
      '/BankToBankRequest/reconcile-bank-to-bank-request',
      {
        bankToBankRequest: {
          ...selectedBankToBankRequest,
          id: selectedBankToBankRequest?.id,
        },
      },
      true,
      'Operation Completed Successfully'
    )

    if (success) {
      onSetMode(null)
      setSelectedBankToBankRequest(null)
      loadData()
    }
  }

  return (
    <>
      <ModalTemplate
        modalMode={mode}
        modalTitle="bankToBankRequests"
        handleClose={closeModal}
        handleAction={() => {
          if (
            Number(stripNonNumericCharacters(apportionedAmount)) !=
            Number(
              stripNonNumericCharacters(selectedBankToBankRequest?.totalAmount)
            )
          ) {
            Swal.fire(
              'Ooops!',
              'apportioned amount should be equal to transaction amount',
              'info'
            )
            return
          } else {
          }
          handleSubmit()
        }}
        modalClassName="modal-xl"
        actionText={mode === 'reconcile' ? 'reconcile' : ''}
        footerChildren={
          <>
            {mode == 'reconcile' ? (
              <>
                <div className="col-3 d-flex align-items-center">
                  <label className="col-3 text-capitalize">
                    {localize('apportioned')}
                  </label>
                  <MaskNumber
                    defaultMaskValue={apportionedAmount || ''}
                    className="form-control ms-2"
                    disabled
                  />
                </div>

                <div className="col-3 d-flex align-items-center">
                  <label className="col-3 text-capitalize">
                    {localize('shortage')}
                  </label>
                  <MaskNumber
                    defaultMaskValue={shortageAmount || ''}
                    className="form-control ms-2"
                    disabled
                  />
                </div>
              </>
            ) : (
              ''
            )}
          </>
        }
      >
        <div className="row mb-2">
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('transactionReferenceCode')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.transactionReferenceCode || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('transactionDate')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.transactionDate || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('totalAmount')}
            </label>
            <MaskNumber
              defaultMaskValue={selectedBankToBankRequest?.paymentAmount || ''}
              className="form-control ms-2"
              disabled
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('currency')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.currency || ''}
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('documentReferenceNumber')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.documentReferenceNumber || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('bankCode')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.bankCode || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('branchCode')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.branchCode || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('paymentDate')}
            </label>
            <input
              type="date"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.paymentDate || ''}
            />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('paymentReferenceCode')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.paymentReferenceCode || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('paymentCode')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.paymentCode || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('paymentMode')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.paymentMode || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('paymentAmount')}
            </label>
            <MaskNumber
              defaultMaskValue={selectedBankToBankRequest?.paymentAmount || ''}
              className="form-control ms-2"
              disabled
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('additionalInfo')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.additionalInfo || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('accountNumber')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.accountNumber || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('accountName')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.accountName || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('institutionCode')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.institutionCode || ''}
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('institutionName')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.institutionName || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('status')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.statusDescription || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('recordStatus')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.recordStatusDescription || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('exceptionMessage')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.exceptionMessage || ''}
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('modifiedBy')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.modifiedBy || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('modifiedDate')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={formatDate(selectedBankToBankRequest?.modifiedDate) || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('createdBy')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.createdBy || ''}
            />
          </div>
          <div className="col d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('createdDate')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={formatDate(selectedBankToBankRequest?.createdDate) || ''}
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-3 d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('serialNumber')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.paddedSerialNumber || ''}
            />
          </div>
          <div className="col-3 d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('chartOfAccountName')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={selectedBankToBankRequest?.chartOfAccountName || ''}
            />
          </div>
          <div className="col-3 d-flex align-items-center">
            <label className="col-4 text-capitalize">
              {localize('costDistributionRule')}
            </label>
            <input
              type="text"
              className="form-control ms-2"
              disabled
              value={
                selectedBankToBankRequest?.chartOfAccountCostDistributionRuleDescription ||
                ''
              }
            />
          </div>
        </div>
        <div
          className="p-2 mt-4"
          style={{
            border: 'solid 1px #0000001f',
            borderRadius: 10,
            position: 'relative',
          }}
        >
          <div
            className="bg-white px-2 row text-capitalize"
            style={{
              position: 'relative',
              top: -20,
              left: 30,
              maxWidth: 'fit-content',
            }}
          >
            {localize('apportionment')}
          </div>

          <div className="col-12 d-flex align-items-center mb-2">
            <label className="col-1 text-capitalize">
              {localize('apportionedTo')}
            </label>
            <EnumsServerCombo
              customContainerStyle={{ width: '100%' }}
              enumsKey="ApportionTo"
              className="form-select ms-1"
              value={selectedCustomer?.apportionToDescription}
              onChange={e =>
                setSelectedCustomer({
                  ...selectedCustomer,
                  apportionTo: e.value,
                })
              }
            />
          </div>

          {selectedCustomer?.apportionTo == 1 ? (
            <>
              <CustomerPartial
                customer={selectedCustomer}
                onCustomerLookup={r => {
                  handleOnSelectCustomer(r)
                }}
              />
              <CustomerAccountPartial
                selectedAccount={selectedAccount}
                onCustomerAccountLookup={r => {
                  handleOnSelectAccount(r)
                }}
                selectedCustomer={selectedCustomer}
              />
            </>
          ) : (
            <>
              <div className="row mb-2">
                <div className="col d-flex align-items-center ms-2">
                  <label className="col-4 text-capitalize">
                    {localize('chartOfAccountName')}
                  </label>
                  <ChartOfAccountsLookup
                    displayValue={selectedCustomer?.chartOfAccountName}
                    onSelect={r => {
                      setSelectedCustomer({
                        ...selectedCustomer,
                        chartOfAccountId: r.id,
                        chartOfAccountName: r.description,
                        customerAccountCustomerAccountTypeTargetProductDescription:
                          r.typeDescription,
                        BankToBankRequestChartOfAccountCostDistributionRuleDescription:
                          r.costDistributionRuleDescription,
                        remarks: r.accountName,
                      })
                    }}
                  />
                </div>
                <div className="col d-flex align-items-center">
                  <label className="col-4 text-capitalize">
                    {localize('accountType')}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    disabled
                    value={
                      selectedCustomer?.customerAccountCustomerAccountTypeTargetProductDescription ||
                      ''
                    }
                  />
                </div>
                <div className="col-6 d-flex align-items-center">
                  <label className="col-2 text-capitalize">
                    {localize('costDistributionRule')}
                  </label>
                  <input
                    type="text"
                    className="form-control ms-2"
                    disabled
                    value={
                      selectedCustomer?.BankToBankRequestChartOfAccountCostDistributionRuleDescription ||
                      ''
                    }
                  />
                </div>
              </div>
            </>
          )}

          <div className="row mb-2">
            <div
              className="col d-flex align-items-center with-validation"
              validation-message={
                globalValidationErrors['ApportionedAmount']?.message
              }
            >
              <label className="col-4 text-capitalize">
                {localize('amount')}
              </label>
              <MaskNumber
                defaultMaskValue={selectedCustomer?.apportionedAmount}
                className="form-control ms-2"
                onMaskNumber={e => {
                  clearValidation('ApportionedAmount')
                  setSelectedCustomer({
                    ...selectedCustomer,
                    apportionedAmount: e.target.value,
                  })
                }}
              />
            </div>
            <div className="col d-flex align-items-center">
              <label className="col-4 text-capitalize">
                {localize('component')}
              </label>
              <EnumsServerCombo
                customContainerStyle={{ width: '100%' }}
                enumsKey="ApportionedComponent"
                value={selectedCustomer?.apportionedComponentDescription}
                onChange={e =>
                  setSelectedCustomer({
                    ...selectedCustomer,
                    apportionedComponent: e.value,
                  })
                }
              />
            </div>
            {selectedCustomer?.apportionTo == 1 ? (
              <div className="col-6 d-flex align-items-center ">
                <label className="col-2 text-capitalize">
                  {localize('remarks')}
                </label>
                <input
                  type="text"
                  className="form-control ms-2"
                  value={
                    selectedAccount?.customerAccountTypeTargetProductDescription ||
                    ''
                  }
                  onChange={e => {
                    clearValidation('Remarks')
                    setSelectedAccount({
                      ...selectedAccount,
                      remarks: e.target.value,
                    })
                  }}
                />
              </div>
            ) : (
              <div className="col-6 d-flex align-items-center ">
                <label className="col-2 text-capitalize">
                  {localize('remarks')}
                </label>
                <input
                  type="text"
                  className="form-control ms-2"
                  value={selectedCustomer?.chartOfAccountName || ''}
                  onChange={e => {
                    setSelectedAccount({
                      ...selectedCustomer,
                      remarks: e.target.value,
                    })
                  }}
                />
              </div>
            )}
          </div>
          <div className="row mb-2">
            <div className="col-3 d-flex align-items-center ms-2">
              <label className="col-4 text-capitalize">
                {localize('loanRepaymentMode')}
              </label>
              <LoanRepaymentModeLookup
                displayValue={selectedCustomer?.loanRepaymentModeDescription}
                onSelect={r => {
                  setSelectedCustomer({
                    ...selectedCustomer,
                    loanRepaymentModeId: r.id,
                    loanRepaymentModeDescription: r.description,
                  })
                }}
              />
            </div>
          </div>
          <div
            className="bg-light d-flex justify-content-end align-items-center p-2"
            style={{ borderRadius: 5 }}
          >
            <button
              onClick={() => {
                addApportionmentEntry(selectedCustomer)
              }}
              className="btn btn-success text-uppercase ms-3 px-4"
            >
              {localize('add')}
            </button>
          </div>

          <div className="col-12 mt-2">
            <Tab
              tabItems={[
                {
                  label: localize('entries'),
                  item: (
                    <BankToBankRequestEntries
                      showLoader={false}
                      selectedBankToBankRequest={selectedBankToBankRequest}
                      handleOnCheckEntry={r => {
                        setEntriesToBeRemoved(r)
                      }}
                      removeSelectedEntries={r => {
                        handleRemoveEntry()
                      }}
                      mode={mode}
                      entryStatus={1}
                      setApportioned={setApportionedAmount}
                      setShortage={setShortageAmount}
                      refreshEntry={refreshEntry}
                    />
                  ),
                },
                {
                  label: localize('customerAccounts'),
                  item: (
                    <BankToBankRequestCustomerAccounts
                      showLoader={false}
                      selectedCustomer={selectedCustomer}
                    />
                  ),
                },
              ]}
            />
          </div>
        </div>
      </ModalTemplate>
    </>
  )
}
export default ReconcileBankToBankDataModal
